import CampaignShipmentsPartial from "../../partials/campaign/campaign-shipments.partial";

export default function CampaignShipmentsScreen() {
  return <CampaignShipmentsPartial />;
}
